
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "EngagementSection",
  props: {
    engagement: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    loaded: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  setup(props) {
    // couponsPerActiveUser is null when the active-user denominator is 0 — the
    // activity bitmaps don't cover this range, so the value is unknown, not zero.
    // Em dash, never "0.00". Same convention as RetentionSection's formatRate.
    const formatPerUser = (v: number | null | undefined) =>
      v === null || v === undefined ? "—" : v.toFixed(2);

    const series = computed(() => [
      { name: "Coupons", data: (props.engagement.coupons ?? []).map((p: any) => p.value) },
    ]);
    const chartOptions = computed(() => ({
      chart: { toolbar: { show: false }, background: "transparent" },
      xaxis: {
        categories: (props.engagement.coupons ?? []).map((p: any) => p.date.slice(0, 10)),
        labels: { style: { colors: "#fff" } },
      },
      yaxis: { labels: { style: { colors: "#fff" } } },
      tooltip: { theme: "dark" },
      dataLabels: { enabled: false },
      plotOptions: { bar: { columnWidth: "45%", borderRadius: 6 } },
      colors: ["#F50242"],
    }));
    return { series, chartOptions, formatPerUser };
  },
});
